import Type from './Type';
export function isIList(node) {
    return node.type === Type.List;
}
export default isIList;    //# sourceMappingURL=isIList.js.map
